export default __webpack_public_path__ + "static/media/sport360.5b65d392.png";